module.exports = __webpack_public_path__ + "img/default_building.62285686.png";